import { JSConn } from "@/utilities/js-conn";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation";

export default {
  name: "FWWorkOrderShow",
  props: {
    workOrderId: String,
  },
  components: {
    LoadingAnimation,
  },
  data() {
    return {
      dataLoaded: false,
      loadingMessage: "Loading the data...",
    };
  },
  computed: {
    workOrder: function() {
      return this.$store.getters.workOrder;
    },
    workOrderNotesCount: function() {
      return this.$store.getters.workOrderNotesCount;
    },
    workOrderTasksCount: function() {
      return this.$store.getters.workOrderTasksCount;
    },
    workOrderFirstTaskId: function() {
      return this.$store.getters.workOrderTaskFirst.id;
    },
    isFieldWorker: function() {
      return this.$store.getters.isFieldWorker;
    },
  },
  created() {
    this.loadWorkOrder().then(() => {
      this.dataLoaded = true;
    });
  },
  methods: {
    loadWorkOrder() {
      const jsConnWorkOrder = new JSConn();

      jsConnWorkOrder.formParams = {
        id: this.workOrderId,
      };

      const dataPromises = [
        this.$store.dispatch("needWorkOrder", jsConnWorkOrder),
      ];

      return Promise.all(dataPromises);
    },
    reloadWorkOrder() {
      // as of 2019-09-24 all the child elements are emitting an event
      // that calls this function. If different things are needed for performance
      // reasons, this can be changed to handle each event separately
      this.dataLoaded = false;
      this.loadWorkOrder().then(dataPromises => {
        this.dataLoaded = true;
        return Promise.resolve(dataPromises);
      });
    },
  },
};
